import { permissionsTranslation, permissionsActiveUsers } from "@/utils";

export const permissionsSupportMenu = [
  ...permissionsTranslation,
  ...permissionsActiveUsers,
];
